(function () {
  function initFlavourFinder(root) {
    if (!root || root.dataset.finderInitialised === 'true') {
      return;
    }

    root.dataset.finderInitialised = 'true';

    const questions = root.querySelectorAll('[data-finder-question]');
    const matches = Array.from(root.querySelectorAll('[data-finder-match]'));

    const resultTitle = root.querySelector('[data-finder-result-title]');
    const resultLink = root.querySelector('[data-finder-result-link]');

    if (!questions.length || !resultTitle || !resultLink) {
      return;
    }

    const fallbackTitle = resultTitle.textContent.trim();
    const fallbackUrl = resultLink.getAttribute('href') || '#';

    function getSelection(question) {
      const active = question.querySelector('.wf-finder__option.is-active');

      return active ? active.dataset.value : null;
    }

    function updateResult() {
      const questionMap = {};

      questions.forEach(function (question) {
        questionMap[question.dataset.finderQuestion] =
          getSelection(question);
      });

      const match = matches.find(function (item) {
        return (
          item.dataset.q1 === questionMap.q1 &&
          item.dataset.q2 === questionMap.q2 &&
          item.dataset.q3 === questionMap.q3
        );
      });

      if (match) {
        resultTitle.textContent =
          match.dataset.title || fallbackTitle;

        resultLink.setAttribute(
          'href',
          match.dataset.url || fallbackUrl
        );
      } else {
        resultTitle.textContent = fallbackTitle;

        resultLink.setAttribute(
          'href',
          fallbackUrl
        );
      }
    }

    questions.forEach(function (question) {
      const options =
        question.querySelectorAll('.wf-finder__option');

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          options.forEach(function (otherOption) {
            otherOption.classList.remove('is-active');

            otherOption.setAttribute(
              'aria-pressed',
              'false'
            );
          });

          option.classList.add('is-active');

          option.setAttribute(
            'aria-pressed',
            'true'
          );

          updateResult();
        });
      });
    });

    updateResult();
  }


  function initAllFlavourFinders(scope) {
    const searchScope = scope || document;

    searchScope
      .querySelectorAll('[data-cc-flavour-finder]')
      .forEach(initFlavourFinder);
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllFlavourFinders(document);
      }
    );
  } else {
    initAllFlavourFinders(document);
  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllFlavourFinders(event.target);
    }
  );
})();